export type TimeZoneOption = {
  tzCode: string;
  tzName: string;
  label: string;
};

export const TIME_ZONE_OPTIONS: TimeZoneOption[] = [
  {
    tzCode: 'ET',
    tzName: 'America/New_York',
    label: 'Eastern Time (ET)',
  },
  {
    tzCode: 'CT',
    tzName: 'America/Chicago',
    label: 'Central Time (CT)',
  },
  {
    tzCode: 'MT',
    tzName: 'America/Denver',
    label: 'Mountain Time (MT)',
  },
  {
    tzCode: 'PT',
    tzName: 'America/Los_Angeles',
    label: 'Pacific Time (PT)',
  },
];
